export enum PostsFilterStateUrlQueryNameEnum {
    createdAtAfter = 'created_at_after',
    createdAtBefore = 'created_at_before',
    statuses = 'status',
    catalogs = 'catalogs_ids',
    tab = 'tab',
}

// Posts list filter sent to the API. `tab` is a UI-only URL param (which list tab is open) and must never be sent.
export type PostsFilterQueriesType = Readonly<{
    [PostsFilterStateUrlQueryNameEnum.createdAtAfter]: string;
    [PostsFilterStateUrlQueryNameEnum.createdAtBefore]: string;
    [PostsFilterStateUrlQueryNameEnum.statuses]: string;
    [PostsFilterStateUrlQueryNameEnum.catalogs]: string;
}>;

// URL query map for the posts page: the filter fields plus the active-tab navigation param.
export type PostsUrlQueriesType = PostsFilterQueriesType & Readonly<{[PostsFilterStateUrlQueryNameEnum.tab]: string}>;
